import React, { useState } from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';

import Dashboard from './pages/Dashboard';
import CandidatesList from './pages/CandidatesList';
import CandidateDetail from './pages/CandidateDetail';
import InterviewsList from './pages/InterviewsList';
import OffersList from './pages/OffersList';
import AIAssistant from './pages/AIAssistant';
import Jobs from './pages/Jobs';
import JobDetail from './pages/JobDetail';
import Profile from './pages/Profile';
import Login from './pages/Login';
import OTP from './pages/OTP';
import Setup2FA from './pages/Setup2FA';

function App() {
  const [loggedIn, setLoggedIn] = useState(
    !!localStorage.getItem("token")
  );

  if (!loggedIn) {
    return (
      <div className="App">
        <Routes>
          <Route path="/" element={
            <Login onLoginSuccess={() => setLoggedIn(true)} />
          } />
          <Route path="/setup-2fa" element={<Setup2FA />} />
          <Route path="/otp" element={
            <OTP onVerified={() => setLoggedIn(true)} />
          } />
        </Routes>

        <ToastContainer position="bottom-right" autoClose={3000} />
      </div>
    );
  }

  return (
    <div className="App">
      <nav className="navbar">
        <h1>HR Portal</h1>
        <ul className="nav-links">
          <li><Link to="/">Dashboard</Link></li>
          <li><Link to="/candidates">Candidates</Link></li>
          <li><Link to="/jobs">Jobs</Link></li>
          <li><Link to="/interviews">Interviews</Link></li>
          <li><Link to="/offers">Offers</Link></li>
          <li><Link to="/ai">AI Assistant</Link></li>
          <li><Link to="/profile">Profile</Link></li>
        </ul>
      </nav>

      <main className="main-content">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/candidates" element={<CandidatesList />} />
          <Route path="/candidates/:id" element={<CandidateDetail />} />
          <Route path="/jobs" element={<Jobs />} />
          <Route path="/jobs/:position" element={<JobDetail />} />
          <Route path="/interviews" element={<InterviewsList />} />
          <Route path="/offers" element={<OffersList />} />
          <Route path="/ai" element={<AIAssistant />} />
          <Route path="/profile" element={<Profile />} />
        </Routes>
      </main>

      <ToastContainer position="bottom-right" autoClose={3000} />
    </div>
  );
}

export default App;

// import React, { useState } from 'react';
// import { Routes, Route, Link } from 'react-router-dom';
// import { ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import './App.css';

// import Dashboard from './pages/Dashboard';
// import CandidatesList from './pages/CandidatesList';
// import CandidateDetail from './pages/CandidateDetail';
// import InterviewsList from './pages/InterviewsList';
// import OffersList from './pages/OffersList';
// import AIAssistant from './pages/AIAssistant';
// import Jobs from './pages/Jobs';
// import JobDetail from './pages/JobDetail';
// import Profile from './pages/Profile';
// import Login from './pages/Login';
// import OTP from './pages/OTP';

// import Setup2FA from "./pages/Setup2FA";


// function App() {
//   const [loggedIn, setLoggedIn] = useState(
//     !!localStorage.getItem("token")
//   );

//   // 🔐 Not logged in → Login / OTP allowed
//   if (!loggedIn) {
//     return (
//       <div className="App">
//         <Routes>
//           <Route
//             path="/"
//             element={<Login onLoginSuccess={() => setLoggedIn(true)} />}
//           />
//           <Route
//             path="/otp"
//             element={<OTP onVerified={() => setLoggedIn(true)} />}
//           />
//         </Routes>

//         <ToastContainer position="bottom-right" autoClose={3000} />
//       </div>
//     );
//   }

//   // ✅ Logged in → Main App
//   return (
//     <div className="App">
//       <nav className="navbar">
//         <div className="navbar-brand">
//           <h1>HR Portal</h1>
//         </div>

//         <ul className="nav-links">
//           <li><Link to="/">Dashboard</Link></li>
//           <li><Link to="/candidates">Candidates</Link></li>
//           <li><Link to="/jobs">Jobs</Link></li>
//           <li><Link to="/interviews">Interviews</Link></li>
//           <li><Link to="/offers">Offers</Link></li>
//           <li><Link to="/ai">AI Assistant</Link></li>
//           <li><Link to="/profile">Profile</Link></li>
//         </ul>
//       </nav>

//       <main className="main-content">
//         <Routes>
//           <Route path="/" element={<Dashboard />} />
//           <Route path="/candidates" element={<CandidatesList />} />
//           <Route path="/candidates/:id" element={<CandidateDetail />} />
//           <Route path="/jobs" element={<Jobs />} />
//           <Route path="/jobs/:position" element={<JobDetail />} />
//           <Route path="/interviews" element={<InterviewsList />} />
//           <Route path="/offers" element={<OffersList />} />
//           <Route path="/ai" element={<AIAssistant />} />
//           <Route path="/profile" element={<Profile />} />
//         </Routes>
//       </main>

//       <ToastContainer position="bottom-right" autoClose={3000} />
//     </div>
//   );
// }

// export default App;

// // import React, { useState } from 'react';
// // import { Routes, Route, Link } from 'react-router-dom';
// // import { ToastContainer } from 'react-toastify';
// // import 'react-toastify/dist/ReactToastify.css';
// // import './App.css';

// // import Dashboard from './pages/Dashboard';
// // import CandidatesList from './pages/CandidatesList';
// // import CandidateDetail from './pages/CandidateDetail';
// // import InterviewsList from './pages/InterviewsList';
// // import OffersList from './pages/OffersList';
// // import AIAssistant from './pages/AIAssistant';
// // import Jobs from './pages/Jobs';
// // import JobDetail from './pages/JobDetail';
// // import Profile from './pages/Profile';
// // import Login from './pages/Login';
// // import OTP from './pages/OTP';  

// // function App() {
// //   const [loggedIn, setLoggedIn] = useState(
// //     !!localStorage.getItem("token")
// //   );

// //   // ✅ LOGIN SCREEN (STILL INSIDE ROUTER)
// //   if (!loggedIn) {
// //     return (
// //       <div className="App">
// //         <Login onLoginSuccess={() => setLoggedIn(true)} />
// //         <ToastContainer position="bottom-right" autoClose={3000} />
// //       </div>
// //     );
// //   }

// //   // ✅ MAIN APP
// //   return (
// //     <div className="App">
// //       <nav className="navbar">
// //         <div className="navbar-brand">
// //           <h1>HR Portal</h1>
// //         </div>

// //         <ul className="nav-links">
// //           <li><Link to="/">Dashboard</Link></li>
// //           <li><Link to="/candidates">Candidates</Link></li>
// //           <li><Link to="/OTP">OTP</Link></li>
// //           <li><Link to="/jobs">Jobs</Link></li>
// //           <li><Link to="/interviews">Interviews</Link></li>
// //           <li><Link to="/offers">Offers</Link></li>
// //           <li><Link to="/ai">AI Assistant</Link></li>
// //           <li><Link to="/profile">Profile</Link></li>
// //         </ul>
// //       </nav>

// //       <main className="main-content">
// //         <Routes>
// //           <Route path="/" element={<Dashboard />} />
// //           <Route path="/candidates" element={<CandidatesList />} />
// //           <Route path="/candidates/:id" element={<CandidateDetail />} />
// //           <Route path="/jobs" element={<Jobs />} />
// //           <Route path="/jobs/:position" element={<JobDetail />} />
// //           <Route path="/interviews" element={<InterviewsList />} />
// //           <Route path="/offers" element={<OffersList />} />
// //           <Route path="/ai" element={<AIAssistant />} />
// //           <Route path="/profile" element={<Profile />} />
// //         </Routes>
// //       </main>

// //       <ToastContainer position="bottom-right" autoClose={3000} />
// //     </div>
// //   );
// // }

// // export default App;

// // // import React, { useState } from 'react';
// // // import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
// // // import { ToastContainer } from 'react-toastify';
// // // import 'react-toastify/dist/ReactToastify.css';
// // // import './App.css';

// // // import Dashboard from './pages/Dashboard';
// // // import CandidatesList from './pages/CandidatesList';
// // // import CandidateDetail from './pages/CandidateDetail';
// // // import InterviewsList from './pages/InterviewsList';
// // // import OffersList from './pages/OffersList';
// // // import AIAssistant from './pages/AIAssistant';
// // // import Jobs from './pages/Jobs';
// // // import JobDetail from './pages/JobDetail';
// // // import Profile from './pages/Profile';
// // // import Login from './pages/Login';


// // // function App() {
// // //   const [loggedIn, setLoggedIn] = useState(false);

// // //   if (!loggedIn) {
// // //     return (
// // //       <div className="App">
// // //         {/* <Login onLogin={() => setLoggedIn(true)} /> */}
// // //         <Login onLoginSuccess={() => setLoggedIn(true)} />
// // //         <ToastContainer position="bottom-right" autoClose={3000} />
// // //       </div>
// // //     );
// // //   }

// // //   return (
// // //     <Router>
// // //       <div className="App">
// // //         <nav className="navbar">
// // //           <div className="navbar-brand">
// // //             <h1>HR Portal</h1>
// // //           </div>
// // //           <ul className="nav-links">
// // //             <li><Link to="/">Dashboard</Link></li>
// // //             <li><Link to="/candidates">Candidates</Link></li>
// // //             <li><Link to="/jobs">Jobs</Link></li>
// // //             <li><Link to="/interviews">Interviews</Link></li>
// // //             <li><Link to="/offers">Offers</Link></li>
// // //             <li><Link to="/ai">AI Assistant</Link></li>
// // //             <li><Link to="/profile">Profile</Link></li>
// // //           </ul>
// // //         </nav>

// // //         <main className="main-content">
// // //           <Routes>
// // //             <Route path="/" element={<Dashboard />} />
// // //             <Route path="/candidates" element={<CandidatesList />} />
// // //             <Route path="/candidates/:id" element={<CandidateDetail />} />
// // //             <Route path="/jobs" element={<Jobs />} />
// // //             <Route path="/jobs/:position" element={<JobDetail />} />
// // //             <Route path="/interviews" element={<InterviewsList />} />
// // //             <Route path="/offers" element={<OffersList />} />
// // //             <Route path="/ai" element={<AIAssistant />} />
// // //             <Route path="/profile" element={<Profile />} />
// // //           </Routes>
// // //         </main>

// // //         <ToastContainer position="bottom-right" autoClose={3000} />
// // //       </div>
// // //     </Router>
// // //   );
// // // }

// // // export default App;
